export interface DnsZoneRecord {
	type: "TXT" | "CNAME"
	/// Fully qualified host, without a trailing dot.
	host: string
	value: string
}

// BIND character-strings cap at 255 bytes, so long DKIM keys have to be split
// into multiple quoted chunks or importers reject the record.
function quoteTxtValue(value: string): string {
	const chunks: string[] = []
	for (let i = 0; i < value.length; i += 255) {
		chunks.push(`"${value.slice(i, i + 255).replace(/"/g, '\\"')}"`)
	}
	return chunks.join(" ")
}

// A BIND zone file is what Cloudflare's "Import and Export" accepts directly;
// most other DNS providers take the same format.
export function buildDnsZoneFile({
	domain,
	records,
	ttl = 3600,
}: {
	domain: string
	records: readonly DnsZoneRecord[]
	ttl?: number
}): string {
	const lines = [
		`;; DNS records for ${domain}`,
		`;; Import this file at your DNS provider, e.g. Cloudflare: DNS > Records > Import and Export.`,
		`$ORIGIN ${domain}.`,
	]
	for (const record of records) {
		const host = `${record.host}.`
		if (record.type === "TXT") {
			lines.push(`${host}\t${ttl}\tIN\tTXT\t${quoteTxtValue(record.value)}`)
		} else {
			lines.push(`${host}\t${ttl}\tIN\tCNAME\t${record.value}.`)
		}
	}
	return lines.join("\n") + "\n"
}
